import React from 'react'
import { CircleCheck } from 'lucide-react'

const icon = props => <CircleCheck size={18} {...props} />

export default icon
